export var ICONS;
(function (ICONS) {
    ICONS["refresh"] = "refresh";
    ICONS["trash"] = "trash";
    ICONS["edit"] = "edit";
    ICONS["download"] = "download";
})(ICONS || (ICONS = {}));
